import {Component, OnInit} from '@angular/core';
import {TlPagination} from '../../../interfaces/general-interfaces';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {ActivatedRoute} from '@angular/router';
import {ListsHttpService} from '../../../services/http-services/lists/lists-http.service';
import {ProfileHttpService} from '../../../services/http-services/profile/profile-http.service';
import {ToastrService} from 'ngx-toastr';
import {ItemInterface} from '../../../interfaces/item-interface';
import {ItemsHttpService} from '../../../services/http-services/items/items-http.service';

@Component({
  selector: 'app-trending-items',
  templateUrl: './trending-items.component.html',
})
export class TrendingItemsComponent implements OnInit {
  urlParams = {page: 1, userId: null};
  trendingItems: any[] = [];
  trendingItemsPagination: TlPagination | undefined;
  isRequestFinish = false;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(private activatedRoute: ActivatedRoute,
              private listsHttpService: ListsHttpService,
              private toastService: ToastrService,
              private itemsHttpService: ItemsHttpService,
              private profileHttpService: ProfileHttpService) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(res => {
      this.urlParams.userId = res.userId;
      this.trendingItems = [];
      this.trendingItemsPagination = undefined;
      this.getTrendingItems();
    });
  }
  getTrendingItems(): void {
    this.isRequestFinish = false;
    this.urlParams.page = this.trendingItemsPagination?.currentPage ? this.trendingItemsPagination.currentPage + 1 : 1;
    this.profileHttpService.getCompanyTrendingItems(this.urlParams).then(res => {
      this.trendingItems = [...this.trendingItems, ...res.data];
      this.trendingItemsPagination = res.pagination;
      this.isRequestFinish = true;
    });
  }

  toggleTrendingItemLike(item: ItemInterface): void {
    const foundedItemIndex = this.trendingItems.findIndex((element: ItemInterface) => element.id === item.id);
    this.trendingItems[foundedItemIndex].am_i_favorite_this_lyst_item = !item.am_i_favorite_this_lyst_item;
    (this.trendingItems[foundedItemIndex].am_i_favorite_this_lyst_item)
      ? this.trendingItems[foundedItemIndex].favorite_users_count++
      : this.trendingItems[foundedItemIndex].favorite_users_count--;
    this.itemsHttpService.addItemToFavorites(item.id).then((res: any) => {
      this.toastService.success(res.message);
    });
  }

  onScroll(event: any): void {
    const threshold = 100;
    const position = event.target.scrollTop + event.target.offsetHeight;
    const height = event.target.scrollHeight;

    if (position > height - threshold && (this.trendingItemsPagination?.currentPage ?? 0) < (this.trendingItemsPagination?.lastPage ?? 0) && this.isRequestFinish) {
      this.getTrendingItems();
    }
  }
}
